import "./styles.scss";
import CampoRadioButton from "../CampoRadioButton";
import CampoDeTexto from "../CampoDeTexto";
import { ChangeEvent, useCallback, useState } from "react";
import { finalizarInativacaoDeInscricao } from "../../servicos/inativacaoDeInscricao";
import { useDispatch } from "react-redux";
import { GerenciadorDeMensagem } from "@digix-ui/componentes";
import { push } from "connected-react-router";

interface InativacaoDeInscricaoconfirmacaoDeInativacaoProps {
  idDaInscricao: number;
}

const InativacaoDeInscricaoconfirmacaoDeInativacao = ({
  idDaInscricao,
}: InativacaoDeInscricaoconfirmacaoDeInativacaoProps) => {
  const [confirmacaoDeInativacao, setConfirmacaoDeInativacao] =
    useState<boolean>(false);
  const [justificativaDeInativacao, setJustificativaDeInativacao] =
    useState<string>("");

  const dispatch = useDispatch();

  const handleCampoRadioButtonInativacao = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value === "true" ? true : false;
      setConfirmacaoDeInativacao(value);
    },
    [idDaInscricao]
  );

  const handleFinalizaInativacao = useCallback(async () => {
    const payload = {
      IdInscricaoOrigem: idDaInscricao,
      Justificativa: justificativaDeInativacao,
    };

    try {
      await finalizarInativacaoDeInscricao(payload);
      GerenciadorDeMensagem.criarMensagem({
        tipo: "sucesso",
        icone: "far fa-check-circle",
        titulo: "Inativacão de inscrição:",
        texto: "Inscrição Inativada com sucesso.",
      });
      dispatch(push("/listagem-de-inscricoes"));
    } catch (error) {
      GerenciadorDeMensagem.criarMensagem({
        tipo: "erro",
        icone: "far fa-times-circle",
        titulo: "Inativacão de inscrição:",
        texto: "Erro ao Inativar inscrição.",
      });
    }
  }, [idDaInscricao, justificativaDeInativacao]);

  return (
    <>
      <form className="container-inativacao-confirmacao-inativacao">
        <div className="container-confirmacao-inativacao-titulo">
          <h2 className="cartao__titulo">Confirme a inativação</h2>
        </div>

        <div className="container-formulario">
          <fieldset className="formulario__grupo-de-inputs">
            <legend className="formulario__label">
              Deseja prosseguir com a inativação?
            </legend>
            <CampoRadioButton
              mesmaLinha
              name="confirmaInativacao"
              value="false"
              label="Não"
              checked={!confirmacaoDeInativacao ? "false" : ""}
              onChange={handleCampoRadioButtonInativacao}
            />
            <CampoRadioButton
              mesmaLinha
              name="confirmaInativacao"
              value="true"
              label="Sim"
              checked={confirmacaoDeInativacao ? "true" : ""}
              onChange={handleCampoRadioButtonInativacao}
            />
          </fieldset>

          <div className="campo-de-texto">
            <CampoDeTexto
              label={"Qual o motivo da inativação?"}
              name={"justificativaDeInativacao"}
              value={justificativaDeInativacao}
              maxLength={450}
              erro={
                confirmacaoDeInativacao && !justificativaDeInativacao
                  ? "Campo obrigatório"
                  : ""
              }
              placeholder={"Explique o motivo da inativação"}
              onChange={(e) => setJustificativaDeInativacao(e.target.value)}
              required={confirmacaoDeInativacao}
            />
          </div>
          <div className="area-botao">
            <button
              className="botao botao_cor-primaria"
              type="button"
              disabled={!confirmacaoDeInativacao || !justificativaDeInativacao}
              onClick={() => handleFinalizaInativacao()}
            >
              Inativar inscrição
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
export default InativacaoDeInscricaoconfirmacaoDeInativacao;
